import * as React from "react";
import { clsx } from "clsx";
import { useEffect, useRef, useState } from "react";
import useAnimationEnd from "@arctheme-hooks/useAnimationEnd";
import { TextField } from "@arctheme-components/elements/TextField/TextField";
import {HeaderMobileMenuLinks} from "./HeaderMobileMenuLinks";
import {HeaderMobileMenuAccount} from "@src/stories/navigation/Header/HeaderMobileMenu/HeaderMobileMenuAccount";
import {HeaderMobileMenuCurrency} from "@src/stories/navigation/Header/HeaderMobileMenu/HeaderMobileMenuCurrency";

export const MobileMenu = ({ link_list, settings }) => {

  const [menuState, setMenuState] = useState({
    menuAnimClass: "",
    accountAnimClass: "",
    isAccountVisible: false,
    isMenuVisible: false,
  });
  const updateMenuState = (updates) =>
      setMenuState((prevState) => ({ ...prevState, ...updates }));


  const [cartItemCount, setCartItemCount] = useState(0);

  const isMenuIconShown = false;
  const slidingDivRef = useRef(null);

  const dispatchCustomEvent = (eventName, detail = { message: "" }) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  };
  const [inputValue, setInputValue] = useState("");


  const useCheckoutButton = false;


  useAnimationEnd(slidingDivRef, () => {
    if (
      menuState.isAccountVisible &&
      menuState.accountAnimClass == "slide-out-to-right"
    ) {
      updateMenuState({
        isAccountVisible: false,
      });

      dispatchCustomEvent("toggle-display-close", {
        message: "header-account",
      });
    }
  });

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const predictiveInput: any = document.getElementById("predictive-search-input");
    if (predictiveInput) {
      predictiveInput.value = value;
      // Trigger onChange event if necessary
      const event = new Event("input", { bubbles: true });
      predictiveInput.dispatchEvent(event);
    }
  };


  const handleSubMenuOpen = () => {
    updateMenuState({
      menuAnimClass: "slide-out-left",
      isAccountVisible: false,
      isMenuVisible: true,
    });
  };

  const handleSubMenuClose = () => {
    updateMenuState({
      menuAnimClass: "slide-in-left",
      accountAnimClass: "slide-out-to-right",
      isMenuVisible: true,
      isAccountVisible: false,
    });

    menuState.isMenuVisible = true;
    menuState.menuAnimClass = "slide-in-left";
    onMenuClick();
    dispatchCustomEvent("megamenu-close");
  };

  const onMenuClick = () => {
    updateMenuState({
      menuAnimClass: "slide-in-left",
      accountAnimClass: "slide-out-left",
      isMenuVisible: true,
      isAccountVisible: false,
    });

    dispatchCustomEvent("mobile-menu-open");
  };

  const onCloseClick = () => {
    updateMenuState({
      accountAnimClass: "slide-out-to-right",
      menuAnimClass: "slide-out-left",
      isAccountVisible: false,
      isMenuVisible: false,
    });

    dispatchCustomEvent("toggle-display-close", { message: "header-account" });
    dispatchCustomEvent("mobile-menu-closed");
    dispatchCustomEvent("megamenu-close");
  };

  const handleBackClick = () => {
    updateMenuState({
      accountAnimClass: "slide-out-to-right",
      menuAnimClass: "slide-in-left",
      isMenuVisible: true,
    });
  };

  const searchInputUpdated = (e) => {
    setInputValue(e.detail.value);
  };

  useEffect(() => {
    const fetchCart = async (event) => {

      try {
        const response = await fetch(`/cart.js`);
        const cartData = await response.json();
        const updatedItemCount = cartData.item_count || 0;
        setCartItemCount(updatedItemCount);
      } catch (error) {
        console.error("Error fetching cart:", error);
      }
    };

    document.addEventListener("liquid-ajax-cart:request-end", function(event: any) {
      const {requestState, cart, previousCart, sections} = event.detail;
      fetchCart({ detail: {} });
    });

    window.addEventListener("megamenu-menu-close", handleSubMenuClose);
    window.addEventListener("searchInputUpdated", searchInputUpdated);
    window.addEventListener("megamenu-menu-open", handleSubMenuOpen);
    return () => {
      window.removeEventListener("megamenu-menu-close", handleSubMenuClose);
      window.addEventListener("searchInputUpdated", searchInputUpdated);
      window.removeEventListener("megamenu-menu-open", handleSubMenuOpen);
      window.removeEventListener('liquid-ajax-cart:request-end', () => {});
    };
  }, []);


  return (
    <div className="mobile-menu-container">
      <nav
        aria-label="Mobile Navigation Overlay"
        className={`navigation-overlay ${clsx({
          open: menuState.isMenuVisible,
          closed: !menuState.isMenuVisible,
        })}`}
        id="mobile-nav"
        role="navigation"
      >
        <button
          className={`flex ${isMenuIconShown ? "block" : "hidden"} mobile_menu-icon`}
          aria-label={menuState.isMenuVisible ? "Close Mobile Navigation" : "Open Mobile Navigation"}
          onClick={menuState.isMenuVisible ? onCloseClick : onMenuClick}
        >
          {!menuState.isMenuVisible ? (
              <i
                aria-hidden="true" onClick={onMenuClick}
                className={`mobile_menu-icon--open ${settings.section.mobile_menu_icon}`}
              ></i>
          ) : (
              <i
                className={`mobile_menu-icon--close ${settings.section.mobile_menu_icon_close}`}
                aria-hidden="true" onClick={onCloseClick}
              ></i>
          )}
        </button>
      </nav>
      <ul
        id="mobile-menu-list"
        className={`relative menu-list -left-[${settings.section.padding_left_right_mobile}px] -right-[${settings.section.padding_left_right_mobile}px] ${menuState.menuAnimClass} ${menuState.isMenuVisible ? "" : "hidden"}`}
        role="menu"
      >
        {settings.section.header_search_bar_position_mobile === 'inside_menu' &&
          <div
            className="mobile-menu-items flex flex-col"
            x-on:click="$store.global.toggleSearch()"
          >
            <TextField
              className={`search-input h4 uppercase`}
              type={"default-input"}
              placeholder={"TYPE TO SEARCH"}
              icon={"magnifying-glass-thin"}
              reverseIcon={true}
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        }

        <HeaderMobileMenuLinks link_list={link_list} settings={settings} updateMenuState={updateMenuState} />

        <div className="mobile-menu-items flex flex-col">

          <HeaderMobileMenuAccount settings={settings} />
          <HeaderMobileMenuCurrency settings={settings} />

          {useCheckoutButton && <div className="flex items-center justify-center button button-primary relative">
            <a href={"/checkout"} className="relative flex items-center gap-4">
              <div className="h5">Checkout</div>
            </a>
          </div>}
        </div>

      </ul>
      <div
        className={`header-mobile-account ${menuState.accountAnimClass} ${menuState.isAccountVisible ? "" : "force-hidden"}`}
      >
        <div
          className="b2 font-medium mobile-menu-item back-button"
          onClick={handleBackClick}
        >
          <i className="icon-chevron-left back-button-icon"></i>
          Back
        </div>
      </div>
    </div>
  );
};
